import Axios from 'axios';
import { QueryClient } from 'react-query';

export const globalQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 60 * 5 * 1000,
      // Retry once only when there's no HTTP response (network/timeout/CORS).
      // HTTP statuses are retried in axios for safe methods only (api/retryPolicy.ts).
      // A cancelled request is an axios error with no response too; skip it.
      retry: (failureCount, error) =>
        Boolean(error?.isAxiosError) &&
        !error.response &&
        !Axios.isCancel(error) &&
        failureCount < 1,
    },
  },
});
